import { gsap } from "gsap";
import DrawSVGPlugin from "gsap/DrawSVGPlugin";
import TextPlugin from "gsap/TextPlugin";
import initHome from "../home";

gsap.registerPlugin(TextPlugin, DrawSVGPlugin);

export default function homeEnterDesktop(data, isMobile, isTouch) {
  if (isMobile) {
    return gsap
      .timeline()
      .set(".wipe-wrapper", {
        autoAlpha: 0,
      })
      .set(data.next.container, {
        autoAlpha: 1,
      })
      .set(".hide-on-load", {
        autoAlpha: 1,
      })
      .from(".home__hero h1", {
        autoAlpha: 0,
        xPercent: -20,
      })
      .from(".home__hero--coord", {
        x: "100vw",
      })
      .from(
        ".home__hero--coord .coord--line",
        {
          width: "0%",
        },
        "<"
      )
      .from(
        ".home__hero--text",
        {
          x: "-100vw",
        },
        "<25%"
      )
      .from(
        ".home__hero--projects, .home__section--1",
        {
          y: "100vh",
          stagger: 0.1,
        },
        "<25%"
      );
  }
  return gsap
    .timeline()
    .set(".wipe-wrapper", {
      autoAlpha: 0,
    })
    .set(data.next.container, {
      autoAlpha: 1,
    })
    .set(".hide-on-load", {
      autoAlpha: 1,
    })
    .from(
      ".home__hero h1",
      {
        xPercent: -20,
        autoAlpha: 0,
      }
    )
    .fromTo(
      ".home__hero--text",
      {
        xPercent: -25,
        autoAlpha: 0,
      },
      {
        xPercent: 0,
        autoAlpha: 1,
      }, 
      "<50%"
    )
    .fromTo(
      ".home__hero--img",
      {
        xPercent: -100,
        autoAlpha: 0,
      },
      {
        xPercent: 0,
        autoAlpha: 1,
      }, 
      "<50%"
    )
    .fromTo(
      ".home__hero--projects",
      {
        yPercent: 50,
        autoAlpha: 0,
      },
      {
        yPercent: 0,
        autoAlpha: 1,
      },
      "<50%"
    )
    .fromTo(
      ".home__section--3--desktop--top",
      {
        xPercent: 10,
        autoAlpha: 0,
      },
      {
        xPercent: 0,
        autoAlpha: 1,
      },
      "<50%"
    )
    .fromTo(
      ".home__hero .coord span",
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
      },
      "<"
    )
    .fromTo(
      ".home__hero .coord--line",
      {
        width: 0,
        autoAlpha: 0,
      },
      {
        width: "100%",
        autoAlpha: 1,
        ease: "none",
      },
      "<"
    )
    .fromTo(
      ".home__hero--bp .draw-on-load",
      {
        drawSVG: "0%",
      },
      {
        drawSVG: "100%",
        ease: "none",
      },
      "<"
    );
}
